/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PieChart from 'loracoms/PieChart';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';
import { toTOAUplinkPieData } from '../selectors';


function toSeries(pieData) {
  const sum = _.sum(_.values(pieData));
  return {
    label: {
      normal: {
        formatter: params => `${Number((params.value / sum) * 100).toFixed(2)}%`,
        fontSize: 10,
      },
      emphasis: {
        formatter: params => `${Number(params.name / 1000000).toFixed(1)}`,
      },
    },
    data: _.map(pieData, (value, name) => ({
      name,
      value,
      label: {
        normal: {
          position: value / sum < 0.1 ? 'outside' : 'inside',
          fontSize: 10,
        },
      },
      labelLine: {
        normal: {
          length: 5,
          length2: 5,
        },
      },
    })),
  };
}


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pieData: React.PropTypes.object.isRequired,
  resize: React.PropTypes.number.isRequired,
};

class GatewayTOAUplinkPie extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pieData: props.pieData,
      resize: props.resize,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statschart');
  }

  componentWillReceiveProps(nextProps) {
    const { pieData, resize } = nextProps;
    if (pieData !== this.props.pieData) {
      this.setState({ pieData });
    }
    if (resize !== this.props.resize) {
      this.setState({ resize });
    }
  }

  render() {
    const { pieData, resize } = this.state;
    return (
      <div className={styles.chart}>
        <PieChart
          series={[toSeries(pieData)]}
          resize={resize}
        />
      </div>
    );
  }
}

GatewayTOAUplinkPie.propTypes = propTypes;

const mapStateToProps = state => ({
  pieData: toTOAUplinkPieData(state),
});

export default connect(mapStateToProps, null)(injectIntl(GatewayTOAUplinkPie));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayTOAUplinkPie/index.jsx